// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__RDUAs","overflowing":"ReadFullNote_overflowing__2R7zH"};